import EventTypeUser from 'domains/models/event_type_user';
import User from 'domains/models/user';
import { z } from 'zod';
import { RoleEnum, UserTypeEnum } from './enum';

export type AdminEventTypeUser = z.infer<typeof schemaAdminEventTypeUser>;
export const schemaAdminEventTypeUser = z.object({
  uid: z.string(),
  name: z.string(),
  profileImage: z.string().nullable(),
  role: RoleEnum,
  userType: UserTypeEnum,
  email: z.string(),
  sort: z.number(),
});

export type EventTypeUserListItem = z.infer<typeof schemaEventTypeUserListItem>;
export const schemaEventTypeUserListItem = z.object({
  uid: z.string(),
  name: z.string(),
  profileImage: z.string().nullable(),
  role: RoleEnum,
  userType: UserTypeEnum,
  sort: z.number().optional(),
  priority: z.number().optional(),
});

export const toListItem = (
  eventTypeUser: EventTypeUser,
  user: User,
): EventTypeUserListItem => {
  return {
    uid: user.uid,
    name: user.name,
    profileImage: user.profileImage,
    role: eventTypeUser.role,
    userType: eventTypeUser.userType,
    sort: eventTypeUser.sort,
    priority: eventTypeUser.priority,
  };
};
